import PropTypes from "prop-types";

function Card({ children, reverse }) {
  const cardStyle = {
    backgroundColor: reverse ? "rgba(0,0,0,0.4)" : "#fff",
    color: reverse ? "#fff" : "#000",
  };

  return (
    <div className="card" style={cardStyle}>
      {children}
    </div>
  );
}

Card.defaultProps = {
  reverse: false,
};
Card.propTypes = {
  children: PropTypes.node.isRequired,
  reverse: PropTypes.bool,
};
export default Card;
